var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'ui-chevron': true,
    'ui-chevron--open': _vm.open
  }},[(_vm.open)?_c('ui-icon',{staticClass:"ui-chevron__icon ui-chevron__icon--up",attrs:{"icon":"far fa-angle-up","color":_vm.color,"size":_vm.size,"disabled":_vm.disabled}}):_vm._e(),(!_vm.open)?_c('ui-icon',{staticClass:"ui-chevron__icon ui-chevron__icon--down",attrs:{"icon":"far fa-angle-down","color":_vm.color,"size":_vm.size,"disabled":_vm.disabled}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }